// ─── Feature switches — the ONE place they live ───────────────────────────────
// Hide, don't delete: every switch here only decides whether existing code is
// reachable. Turning one back on restores the old screens unchanged.
//
// Decisions behind the defaults: "YogaStay — Claude Code Instructions" →
// Decisions table, answered 18 Oct 2026, and YOGASTAY_IMPROVEMENT_PLAN.md Part B.
//
// All fail closed: anything other than the exact string "true" means off.
const on = (v) => v === "true";

// Online payments (Razorpay). YogaStay is enquiry-only for Indian cross-border
// remittance rules. Turning this on takes BOTH halves — the browser flag alone
// cannot create an order, because create-razorpay-order refuses on its own flag:
//   1. Vercel env:               REACT_APP_PAYMENTS_ENABLED=true   (then redeploy)
//   2. Supabase function secret: supabase secrets set PAYMENTS_ENABLED=true
// While off: no checkout, and no commission, earnings, payout, platform-fee or
// revenue screens anywhere (school portal, teacher dashboard, admin).
export const PAYMENTS_ENABLED = on(process.env.REACT_APP_PAYMENTS_ENABLED);

// Paid verification ($29/month, $249/year). Decision: free during launch —
// verification is an admin review only; no plan picker, no Pay buttons.
export const VERIFICATION_PAID = on(process.env.REACT_APP_VERIFICATION_PAID);

// Independent teachers ("Yoga Gurus") and their online classes. Decision
// 18 Oct 2026: shown again — gurus list for free and students send enquiries.
// Their payouts and Teacher Pro subscription stay hidden while
// PAYMENTS_ENABLED is off. ON unless explicitly switched off with
// REACT_APP_INDEPENDENT_TEACHERS=false (the one switch here that is not
// fail-closed, because showing it is the decision).
export const INDEPENDENT_TEACHERS = process.env.REACT_APP_INDEPENDENT_TEACHERS !== "false";
